import React from 'react';
import { useNavigate } from 'react-router-dom';

const RequestCallErrorScreen: React.FC = () => {
	const navigate = useNavigate();

	return (
		<div className="center-center-content">
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>Your family’s comfort and peace of mind matter deeply to us.</p>
					<p>
						A member of our care team will reach out shortly to provide personalized guidance and discuss service options and times
						availability.
					</p>
					<p>
						If you need immediate assistance call
						{' '}
						<span className="inline-block">
							<a href="tel:+8553272325" className="inline-link">
								(855) 327-2325.
							</a>
						</span>
					</p>
				</div>

				<button onClick={() => navigate('/')} className="btn btn-primary link">
					Done
				</button>
			</div>
		</div>
	);
};

export default RequestCallErrorScreen;
